import { useForm } from "@shared/features/form/useForm";
import { Form } from "@shared/features/form/Form";
import { ActionButtonsGroup } from "@shared/ui/ActionButtonsGroup";
import { makeFormFields } from "@shared/utils/makeFormFields";
import { useUpdatePasswordMutation } from "../../hooks/useUpdatePasswordMutation";
import { PasswordRequirementsContainer } from "../PasswordRequirements/PasswordRequirementsContainer";
import { baseUpdatePasswordSchema } from "../../auth.schemas";
import { User } from "../../auth.types";

export type Props = {
  user: User | null;
};

export function UpdatePasswordForm({ user }: Props) {
  const schema = baseUpdatePasswordSchema;

  const fields = makeFormFields([
    "currentPassword",
    "password",
    "confirmPassword",
  ]).map((field) => {
    if (field.name === "currentPassword") {
      return {
        ...field,
        autoComplete: "current-password",
        layout: "horizontal",
      };
    }

    if (field.name === "password") {
      return {
        ...field,
        placeholder: "Enter your new password",
        layout: "horizontal",
        autoComplete: "new-password",
      };
    }

    if (field.name === "confirmPassword") {
      return {
        ...field,
        placeholder: "Confirm your new password",
        layout: "horizontal",
        autoComplete: "new-password",
      };
    }
    return { ...field, layout: "horizontal" };
  });

  const onSuccess = (data: any) => {};

  const passwordMutation = useUpdatePasswordMutation({
    onSuccess,
    schema,
    currentEmail: user?.email || "",
  });

  const { form, handleSubmit } = useForm({
    schema,
    onSubmit: passwordMutation.mutateAsync,
  });

  const handleCancel = () => {
    form.reset();
  };

  const { isSubmitting, isLoading, isValid, isDirty } = form.formState;

  return (
    <div className="flex flex-col gap-4 w-full">
      <Form
        fields={fields}
        form={form}
        errorContainerClassName="p-0 w-full max-w-full mt-8"
      >
        <PasswordRequirementsContainer layout="horizontal" />
      </Form>
      <ActionButtonsGroup
        primaryButtonText={"Update Password"}
        onPrimaryClick={handleSubmit}
        secondaryButtonText={isDirty ? "Cancel" : undefined}
        onSecondaryClick={isDirty ? handleCancel : undefined}
        className="size-max w-fit self-end"
        primaryButtonProps={{
          disabled: !isDirty || !isValid || isSubmitting || isLoading,
        }}
      />
    </div>
  );
}

export default UpdatePasswordForm;
